import type { ReactNode } from "react";

import { Badge } from "./Badge";
import { Button } from "./Button";
import { cn } from "./lib/cn";

export interface FilterBarProps {
  /** Arama alanı — sayfa kendi `<Input>`'unu (ikon, `key` sıfırlama vb.) tam denetimle verir. */
  search?: ReactNode;
  /** Kalıcı görünen süzgeçler (mockup: Durum/Tür/Sorumlu select'leri) — sayfa kendi verir. */
  filters?: readonly ReactNode[];
  /** "Filtrele" düğmesi — yalnız daha fazla alan bir çekmecede duruyorsa verilir. */
  onOpenDrawer?: () => void;
  /** "Filtrele" düğmesinin ikonu (mockup: sliders-horizontal) — ikon seti domain'de. */
  filterIcon?: ReactNode;
  /** Çekmecedeki aktif süzgeç sayısı — düğmenin üstünde rozet olarak görünür. */
  activeCount?: number;
  /** Sağdaki sıralama kontrolü (mockup: "Sırala: Son güncelleme ▾"). */
  sort?: ReactNode;
  className?: string;
}

/**
 * Filtre çubuğu — UI Tur 2 §5. Mockup'ın liste sayfalarındaki üst şerit: arama + kalıcı
 * süzgeçler + "Filtrele (n)" + sıralama. Bileşen domain BİLMEZ: hangi süzgeçlerin
 * olduğunu sayfa `filters` dizisiyle veriyor, bu yalnız YERLEŞİM.
 */
export function FilterBar({
  search,
  filters = [],
  onOpenDrawer,
  filterIcon,
  activeCount = 0,
  sort,
  className,
}: FilterBarProps) {
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      {search ? <div className="min-w-64 flex-1">{search}</div> : null}
      {filters.map((filter, i) => (
        <div key={i} className="min-w-40">
          {filter}
        </div>
      ))}
      {onOpenDrawer ? (
        <Button variant="secondary" icon={filterIcon} onClick={onOpenDrawer}>
          Filtrele
          {activeCount > 0 ? <Badge tone="primary">{activeCount}</Badge> : null}
        </Button>
      ) : null}
      {sort ? <div className="ml-auto min-w-48">{sort}</div> : null}
    </div>
  );
}
